/**
 * Worker instance is defined here, so the import can be mocked in tests as long as jest doesn't have proper esm support.
 * See {@link /src/test/web-worker.mock.ts}
 */
const resultPdfWorkerInstance = new Worker(new URL('../result-pdf.worker', import.meta.url))
export default resultPdfWorkerInstance
